import { Outlet, createRootRoute, createRoute, createRouter } from '@tanstack/react-router'
import { createCommonsRoutes } from 'vcode-commons-ui'
import AccountsPage from './AccountsPage'
import AdminBanksPage from './AdminBanksPage'
import HomePage from './HomePage'
import NewAccountPage from './NewAccountPage'

// Connexion, profil et administration des utilisateurs viennent de
// vcode-commons-ui ; seules les routes metier sont declarees ici.
const rootRoute = createRootRoute({ component: Outlet })

const indexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  component: HomePage,
})

/** `?created=<libelle>&pending=true` : retour de l'ecran de creation. */
interface AccountsSearch {
  created?: string
  pending?: boolean
}

const accountsRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/accounts',
  validateSearch: (search: Record<string, unknown>): AccountsSearch => ({
    ...(typeof search.created === 'string' ? { created: search.created } : {}),
    ...(search.pending === true || search.pending === 'true' ? { pending: true } : {}),
  }),
  component: AccountsPage,
})

const newAccountRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/accounts/new',
  component: NewAccountPage,
})

const adminBanksRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/admin/banks',
  component: AdminBanksPage,
})

export const routeTree = rootRoute.addChildren([
  indexRoute,
  accountsRoute,
  newAccountRoute,
  adminBanksRoute,
  ...createCommonsRoutes(rootRoute),
])

export const router = createRouter({ routeTree })

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
